import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import ContentContainer from '../../components/ContentContainer';
import PageTitle from '../../components/PageTitle';
import NewslettersForm from '../../components/NewslettersForm';
import Spinner from '../../components/Spinner';
import withUser from '../../hoc/withUser';
import { useStore } from '../../store';

const NewslettersPage = observer(({ user, authToken }) => {
  const {
    rootStore: {
      profileStore,
      profileStore: { newsletterStore },
    },
  } = useStore();

  const { i18n } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      if (!profileStore.profileData) {
        await profileStore.initProfile(user, authToken, i18n);
      }

      await profileStore.loadUser();
      if (!newsletterStore.lists) {
        await newsletterStore.getSubscriptionDetails(user);
      }
      newsletterStore.clearAlerts();
    };

    fetchData();

    return () => {
      profileStore.newsletterStore.clearLists();
    };
    // eslint-disable-next-line
  }, []);

  const interests = newsletterStore.interests;
  const language = newsletterStore.language;

  return (
    <>
      <ContentContainer>
        <PageTitle titleKey={'newsletters.title'} subtitleKey={'newsletters.subtitle'} />
        {language && interests && interests.length ? (
          <NewslettersForm interests={interests} language={language} />
        ) : (
          <Spinner pageLoading />
        )}
      </ContentContainer>
    </>
  );
});

export default withUser(NewslettersPage);
